import * as yup from 'yup';

import {$isNG} from '../../../models/utils';

const baseLabelValueSchema = yup
    .object({
        label: yup
            .string()
            .nullable()
            .notRequired(),
        value: yup
            .string()
            .nullable()
            .notRequired(),
    })
    .nullable()
    .notRequired();

const selectShape = baseLabelValueSchema;

export const lineSchema = yup.object().shape({
    itemCode: yup.string().required(),
    description: yup.string().required(),
    qty: yup
        .number()
        .positive()
        .required(),
    price: yup
        .number()
        .positive()
        .required(),
    vatCategory: selectShape.required(),
    vat: yup.number().required(),
    serviceCategory: $isNG.getState() ? selectShape.required() : selectShape.nullable(),
});

export const generalInfoSchema = yup.object({
    test: yup
        .array()
        .of(lineSchema)
        .min(1),
});

const extraFieldsShape = yup.number().when('$extraFileds', {
    is: true,
    then: (schema) => schema.required(),
    otherwise: (schema) => schema.nullable(),
});

export const chargesModalSchema = yup.object().shape({
    reason: yup.string().required(),
    amountXaf: yup.number().required(),
    ratePercent: extraFieldsShape,
    baseAmount: extraFieldsShape,
});

type ValidationContext = {
    IS_NG: boolean;
};

export const createValidationContext = (
    x?: Record<string, string | number | boolean>,
): ValidationContext => ({
    ...x,
    IS_NG: $isNG.getState(),
});

const resolveFieldSchema = (fieldSchema: any, context: ValidationContext) => {
    if (!fieldSchema) {
        return null;
    }

    if (typeof fieldSchema.resolve === 'function') {
        return fieldSchema.resolve({
            context,
        });
    }

    return fieldSchema;
};

const hasRequiredTest = (schema: any) => {
    if (!schema) {
        return false;
    }

    // eslint-disable-next-line no-underscore-dangle
    const exclusiveTests = schema.exclusiveTests ?? schema._exclusive;
    if (exclusiveTests?.required) {
        return true;
    }

    const tests = schema.tests ?? [];
    return tests.some((test: any) => test?.OPTIONS?.name === 'required');
};

export const createIsFieldRequired = (context: ValidationContext, schema?: any) => {
    const resolvedSchema = schema
        ? schema.resolve({context})
        : generalInfoSchema.resolve({context});

    return (name: string) => {
        const fieldSchema = resolvedSchema.fields[name as keyof typeof resolvedSchema.fields];
        const concreteSchema = resolveFieldSchema(fieldSchema, context);

        return hasRequiredTest(concreteSchema);
    };
};
